<div class="container">
  <div class="payNowContainer">
    <div class="header">AMOUNT TO PAY NOW</div>
    <div class="amount" (click)="onEditAmount()">
      <span>£{{ amountToPay }}</span>
      @if (viewModel.canEditAmount) {
        <ion-icon name="pencil-outline"></ion-icon>
      }
    </div>
    <div class="footer">
      <ion-icon name="information-circle-outline"></ion-icon
        ><span> {{ viewModel.canEditAmount ? 'Split payments allowed' : 'Single payment required' }}</span>
      </div>
    </div>
    <hr />
    @if (viewModel.canPayWithGooglePay) {
      <div class="paymentButton googlePayButton">
        <ion-button class="google-pay-button" color="black" (click)="onPayWithGooglePay()">
          <div class="google-pay-button-content"></div>
        </ion-button>
      </div>
    }

    @if (viewModel.canPayWithApplePay) {
      <div class="paymentButton applePayButton">
        <ion-button class="apple-pay-button apple-pay-button-black" fill="clear" (click)="onPayWithApplePay()">
        </ion-button>
      </div>
    }

    @if (viewModel.canPayWithGooglePay || viewModel.canPayWithApplePay) {
      <div class="orSeparator">OR</div>
    }

    @if (viewModel.method) {
      <div class="cardForm">
        <div class="paymentButton cardPayButton">
          <ion-button
            [ngClass]="{ androidButton: platform.is('android'), iosButton: platform.is('ios') }"
            class="paymentButton"
            shape="round"
            color="secondary"
            (click)="onConfirm()"
            >Pay with card <span class="asterisks">&nbsp;&nbsp;****&nbsp;</span>
            {{ viewModel.method?.cardLast4 }}</ion-button
            >
          </div>
          <div class="methodContainer">
            <ion-button class="secondaryTextLink" type="button" fill="clear" (click)="onChooseMethod()"
              >CHANGE METHOD
            </ion-button>
          </div>
        </div>
      }

      <div class="paymentButton cardPayButton">
        @if (!viewModel.method) {
          <ion-button
            [ngClass]="{ androidButton: platform.is('android'), iosButton: platform.is('ios') }"
            class="paymentButton"
            shape="round"
            color="secondary"
            (click)="onChooseMethod()"
            >Add / Select Card</ion-button
            >
          }
        </div>

        @if (viewModel.error) {
          <div class="outerPaymentErrorCont">
            <div class="paymentErrorCont">
              <p>{{ viewModel.error }}</p>
            </div>
          </div>
        }
      </div>
